// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import Signup from "src/components/pages/Signup/Signup"
import Layout from "src/layouts/fr"

const SignupPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `signupPage.sections`, [])
  const signupForm = _.get(data, `signupForm`)
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.signupPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Signup sections={sections} signupForm={signupForm} lang="fr" />
    </Layout>
  )
}

export default SignupPageFr

export const query = graphql`
  query SignupPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    signupPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    signupForm: strapiSignupForm(locale: { eq: "fr" }) {
      fields: strapi_fields {
        uuid
        strapi_component
        placeholder
        order
        name
      }

      submitText
    }

    testimonials: allStrapiTestimonial(filter: { locale: { eq: "fr" } }) {
      nodes {
        name
        quote
        credit
        order
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
